<div *ngIf="organisationTypeId != 2 && taskId != 0" class="">
  <p-panel styleClass="panel-shadow">
    <p-header> Driver Performance </p-header>
    <div class="">
      <p-chart
        *ngIf="driverLineData && driverLineOptions"
        [data]="driverLineData"
        [options]="driverLineOptions"
        height="350px"
        type="line"
      ></p-chart>
    </div>
  </p-panel>
</div>
